import { useState, useEffect } from 'react';
import EcoVideo from 'eco-design/base/eco-video';
import css from './index.module.scss';
import ProductAccessoriesDisplay from './ProductAccessoriesDisplay';
import { useLang } from '@/i18n';

const G: React.FC = () => {
    const { t } = useLang('rapidpro');
    const [enter, setEnter] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined' && window?.AniContainer) {
            setTimeout(() => {
                let video: HTMLVideoElement | null = null;
                const winH = window.innerHeight;
                const scene1 = AniContainer.create({
                    triggerElement: '.rapid-pro-G',
                    triggerHook: 1,
                    offset: '50%',
                    duration: '500%',
                    onEnter: () => setEnter(true),
                    onLeave: () => setEnter(false),
                });

                const scene2 = AniContainer.create({
                    triggerElement: '.rapid-pro-G',
                    triggerHook: 1,
                    offset: winH * 2,
                    duration: winH * 0.2,
                    asyncFromTo: [
                        ['.rapid-pro-G .media', { opacity: 1 }, { opacity: 0 }, 1],
                        ['.rapid-pro-G .box', { opacity: 0 }, { opacity: 1 }, 1],
                    ],
                    asyncTimeLine: [9, 9],
                });

                const scene3 = AniContainer.create({
                    triggerElement: '.rapid-pro-G',
                    triggerHook: 1,
                    offset: winH * 0.5,
                    duration: winH,
                    onEnter: () => {
                        if (!video) {
                            video = document.querySelector('#rapid-pro-G .media video');
                        }
                        if (video) {
                            video.currentTime = 0;
                            video.play();
                        }
                    },
                });

                return () => {
                    scene1?.destroy();
                    scene2?.destroy();
                    scene3?.destroy();
                };
            }, 3000);
        }
    }, []);

    return (
        <div id="rapid-pro-G" className={`rapid-pro-G ${css.section}`}>
            <div className="sticky">
                <div className="media">
                    <EcoVideo
                        pc="https://websiteoss.ecoflow.com/upload/video/1749203485135/7.mp4"
                        h5="https://websiteoss.ecoflow.com/upload/video/1749203484978/7_M.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1749863711769/7.jpg"
                    />
                </div>
                <div className={`info${enter ? ' enter' : ''}`}>
                    <p className="info-title">{t('G_title')}</p>
                    <p className="info-desc">{t('G_desc')}</p>
                </div>
                {/* 产品展示模块 */}
                <ProductAccessoriesDisplay />
            </div>
        </div>
    );
};

export default G;
